import React, { useContext, useEffect } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { LessonMode } from '../../../Constants';
import FeedbackIcon from '../FeedbackIcon';
import Guideline from '../tools/Guideline';
import HtmlComponent from '../HtmlComponent';
import OptionalImage from '../OptionalImage';
import useStyleEvents from '../../../hooks/useStyleEvents';
import PrintQuestionNumber from './PrintQuestionNumber';
import { register } from '../../../i18n';

const t = register('GlobalQuestionLabels');

const AlchemieTestItem = observer(({ lessonElementId }) => {
  const {
    lessonManager,
    messageManager,
    responseManager,
    toolbarManager
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const textBody = model.questionText || '';

  const lessonElementState = responseManager.getLessonElementState(lessonElementId);

  if (!lessonElementState) {
    return (<div className='alchemie-test-item' />);
  }

  useStyleEvents(lessonElementId);

  useEffect(() => {
   
    if ((lessonElementState.isSubmitted && lessonElementState.cachedResponseAnswer)) {
      messageManager.updateMessage(model.parentActivityElementId, { goal: lessonElementState.cachedResponseAnswer.goal, from: lessonElementId, startCode: model.startCode });
    } else if (lessonElementState.currentResponseAnswer && lessonElementState.currentResponseAnswer.goal) {
      messageManager.updateMessage(model.parentActivityElementId, { goal: lessonElementState.currentResponseAnswer.goal, from: lessonElementId, startCode: model.startCode });
    } else  if (!model.unscored){
      messageManager.updateMessage(model.parentActivityElementId, { goal: '', from: lessonElementId, startCode: model.startCode });
    }
  }, [lessonElementState.isSubmitted]);

  return (
    <div className='alchemie-test-item-question'>
      {toolbarManager.isGuidelineOpen && <Guideline lessonElementId={lessonElementId} />}
      <div className='test-item-question alchemie-test-item'>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && <PrintQuestionNumber model={model} />}
        <HtmlComponent htmlStr={textBody} />
      </div>
      <OptionalImage model={model} runtime={true} />
      <div className='test-item-answers' />
    </div>
  );
});

export default AlchemieTestItem;
